import { Skeleton } from '@immo/ui-kit';

/**
 * The wait for a full-screen round-trip that has **no content shape to mirror**
 * — a hydrate fallback that cannot know the incoming route, an OAuth callback
 * whose next move is a redirect. Everywhere the wait *will* be replaced by
 * known content, use a skeleton shaped like that content instead; this is the
 * deliberate fallback for the cases where no such shape exists (IMM-743.2).
 *
 * A sibling of `AuthWaiting` (`pages/auth/components/auth-status-card.tsx`),
 * not a replacement for it: that one belongs to the auth landers and carries
 * `AuthFrame`'s branding, which does not belong on a settings callback.
 *
 * Renders the bars and the words, deliberately both. Bars alone leave someone
 * on a slow connection watching grey rectangles with no explanation; the bars
 * are `aria-hidden` so the wait is announced once, by the caption, rather than
 * once per bar.
 *
 * The caller owns the page frame (`min-h-screen`, background, centring) — this
 * is the column that goes inside it.
 */
export function WaitingScreen({ message }: { message: string }) {
  return (
    <div className="mx-auto w-full max-w-sm">
      <div className="flex flex-col gap-3" aria-hidden>
        <Skeleton className="h-5 w-[62%]" />
        <Skeleton className="h-3.5 w-full" />
        <Skeleton className="h-3.5 w-[78%]" />
      </div>
      <p className="mt-4 text-text-secondary" aria-live="polite">
        {message}
      </p>
    </div>
  );
}
